import { capitalize as capitalizeFn } from 'lodash';

export const getLabeledItemCount = (
  count: number,
  itemName: string,
  capitalize = false,
) =>
  `${count} ${count === 1 ? itemName : `${capitalize ? capitalizeFn(itemName) : itemName.toLowerCase()}s`}`;
